
@if (loading) {
  <div class="container-loader h-100">
    <div class="loader loader-img"></div>
  </div>
}

@if (!loading) {
  <div class="box-dashboard h-100"
    [ngClass]="{'full-screen': graphsFullScreen['days_out']}">
    <span class="title-child" [ngStyle]="{ 'font-size.px': titleSize}">
      {{'Day out of days' | translate}}
    </span>
    <div class="buttons-container">
      <span class="material-icons full-btn"
        (click)=" _gS.toggleGraphFullscreen(graphsFullScreen,'days_out'); toggleFix()">
        {{graphsFullScreen['days_out'] ? 'fullscreen_exit': 'fullscreen'}}
      </span>
    </div>
    <div class="TableConteiner" [ngClass]="{ 'mar-sm': mb }"
      infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50"
      [scrollWindow]="false" (scrolled)="onScroll($event)" [horizontal]="true">
      <table>
        <thead>
          <tr>
            <th class="sticky-left" [attr.rowspan]="2">
              <div  [ngStyle]="{'width': widthDescription + 'px'}">{{titleDescription | translate}}</div>
            </th>
            @if (showWorkDetails) {
              <th class="gap"></th>
              <th [attr.colspan]="3">{{ 'Details' | translate }}</th>
            }
            @for (week of weeks; track week; let i = $index) {
              <th class="gap"></th>
              <th [attr.colspan]="week.days.length">
                <span>{{'$week_initial' | translate}}{{i+1}} - </span>
                <span>{{week.start_week | date:'MMM d'}} </span>
                <span>{{'to' | translate}}</span>
                <span> {{week.end_week | date: 'MMM d'}}</span>
              </th>
            }
          </tr>
          <tr>
            @if (showWorkDetails) {
              <th class="gap"></th>
              <th>
                <div class="detail-col">{{'Date start' | translate}}</div>
              </th>
              <th>
                <div class="detail-col">{{'Date end' | translate}}</div>
              </th>
              <th>
                <div class="detail-col">{{'Worked days' | translate}}</div>
              </th>
            }
            @for (week of weeks; track week; let i = $index) {
              <th class="gap"></th>
              @for (day of week.days; track day) {
                <th class="second-sticky">
                  <div class="value">
                    @if (day.showMonth) {
                      <span>{{day.date | date: 'MMMMM'}}</span>
                      }{{day.date | date: 'd'}}
                    </div>
                  </th>
                }
              }
            </tr>
          </thead>
          <tbody>
            @for (element of dayOufDays | slice:sliceStart:(sliceStart + sliceSize); track element) {
              <tr>
                <td class="sticky-left">
                  <div class="AlignLeft" [ngStyle]="{'width': widthDescription + 'px'}">{{element.description}}</div>
                </td>
                @if (showWorkDetails) {
                  <td class="gap"></td>
                  <td>
                    <div>{{element?.start_work ? (element.start_work | date: 'MMM-dd-yyyy') : '--'}}</div>
                  </td>
                  <td>
                    <div>{{element?.finish_work ? (element.finish_work | date: 'MMM-dd-yyyy') : '--'}}</div>
                  </td>
                  <td>
                    <div>{{element?.days_work || '--'}}</div>
                  </td>
                }
                @for (week of element.project_weeks; track week; let i = $index) {
                  <td class="gap"></td>
                  @for (day of week.days; track day) {
                    <td>
                      <div class="td-container">
                        <div class="type"
                        [ngClass]="day.day_work">{{day.day_work}}</div>
                      </div>
                    </td>
                  }
                }
              </tr>
            }
          </tbody>
        </table>
        @if (pagination) {
          <div class="tablePagination">
            <!-- <i class="first" (click)="changePagPosition('first')" *ngIf="sliceStart > 0"></i> -->
            @if (sliceStart > 0) {
              <i class="previous" (click)="changePagPosition('previous')"></i>
            }
            <div class="values">
              {{sliceStart + 1}} {{'To' | translate }} {{(sliceStart + sliceSize) < dayOufDays.length ? (sliceStart + sliceSize) : dayOufDays.length}} {{'Of' | translate}} {{dayOufDays.length}}
            </div>
            @if (sliceStart + sliceSize < dayOufDays.length) {
              <i class="next" (click)="changePagPosition('next')"></i>
            }
            <!-- <i class="last" (click)="changePagPosition('last')" *ngIf="sliceStart + sliceSize < dayOufDays.length"></i> -->
          </div>
        }
      </div>
    </div>
  }